/* fbp-slot-availability.js
   ------------------------------------------------------------
   Intentionally disabled.
   This file previously handled "Sold Out for Today" UI + hard-blocking.
   The current system is handled by: fb-capacity-gate.js

   Keep this file as a safe stub so:
   - it cannot conflict with the capacity gate
   - any legacy references to window.FBP_SlotAvailability won’t throw errors
   ------------------------------------------------------------
*/
(() => {
  window.FBP_SlotAvailability = window.FBP_SlotAvailability || {};
  window.FBP_SlotAvailability.version = "disabled-stub";
  window.FBP_SlotAvailability.loadedAt = new Date().toISOString();

  // Legacy no-op methods (so calls won’t crash)
  window.FBP_SlotAvailability.run = async () => ({ disabled: true });
  window.FBP_SlotAvailability.fetchSlotAvailable = async () => true;
  window.FBP_SlotAvailability.isCommissionProductPage = () => false;

  // Optional breadcrumb (comment out if you don't want console noise)
  // console.info("[FBP] fbp-slot-availability.js is disabled (capacity gate owns gating).");
})();
